export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
    visible: that.showDefaultImage,
  },
  {
    title: that.$l('INDEX.table_label_goods_spec_no') || '产品规格编号',
    field: 'orderGoodsSpecNo',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goods_spec_name') || '产品规格名称',
    field: 'orderGoodsSpecName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_englishSize') || '英文尺寸',
    field: 'v_englishSize',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_spec_title') || '产品规格',
    field: 'spec',
    minWidth: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'specInfo' },
  },
  {
    title: that.$l('INDEX.order_spec_label_spec_inGroupQty') || '规格数量',
    field: 'inGroupQty',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_qty') || '订购数量',
    field: 'qty',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_materialDesc') || '面料说明',
    field: 'materialDesc',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_accessoriesDesc') || '辅料说明',
    field: 'accessoriesDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_technologyDesc') || '工艺要求说明',
    field: 'technologyDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_smallPackageDesc') || '小包装说明',
    field: 'smallPackageDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_spec_label_innerPackageDesc') || '内包装说明',
    field: 'innerPackageDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
